import { Component, OnInit } from '@angular/core';
import {ConfService} from '../../conf.service';
import {ActivatedRoute} from '@angular/router';
import {QueryBuilderConfig} from 'angular2-query-builder';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

declare let $;
@Component({
    selector: 'app-editor',
    templateUrl: './editor.component.html',
    styleUrls: ['./editor.component.css']
})
export class EditorComponent implements OnInit {


    partner: any;
    account: string;
    items: any;
    databaseList = [];
    dbItem: any;
     query = {
         condition: 'and',
         rules: [
             /*{field: 'age', operator: '=', value: ''}*/
         ]
     };
    config: QueryBuilderConfig;
    tableList: any;
    attributeList: any;
    methodList = ['GET', 'POST'];
    method: string;
    attribute: string;
    database: string;
    tableSelected: string;
    operationName: string;
    entityList: any;
    fields: any;
    attributeSelected = []
    dbObj: any;
    enablequery: boolean;
    enableQuerySection: boolean;
    scope = [{'displayName': 'Public', 'value': 'public', 'checked': true},
        {'displayName': 'Private', 'value': 'private', 'checked': false}];
    scopeSelected = 'public';
    level = [{'displayName': 'Only ' + localStorage.getItem('account'), 'value': 'account', 'checked': true},
        {'displayName': 'All Accounts', 'value': 'partner', 'checked': false}];
    levelSelected = 'account';
    constructor(private confPost: ConfService, private route: ActivatedRoute, public platform: LeftpanelComponent) {
        this.config = {
            fields: {
            }
        };
    }

    ngOnInit() {
        if (this.platform.queryBuilderAttributes !== null && this.platform.queryBuilderAttributes !== undefined) {
            this.dbItem = this.platform.queryBuilderAttributes[0];
            this.dbItem.databases.forEach((dblist) => {
                this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                this.setSection();
            });
        } else {
            this.confPost.getAttributesForQueryBuilder(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(db => {
                this.dbItem = db[0];
                this.platform.queryBuilderAttributes = db;
                this.dbItem.databases.forEach((dblist) => {
                    this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                    this.setSection();
                });
            });
        }
        // this.confPost.getAttributesForQueryBuilder(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(db => {
        //     this.dbItem = db[0];
        //     this.dbItem.databases.forEach((dblist) => {
        //         this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
        //         this.setSection();
        //     });
        // });
    }
    setSection() {
        this.route.queryParams
            .subscribe(params => {
                this.partner = params.partner;
                this.account = params.account;
                this.operationName = params.operation;
                this.confPost.getCustomOperation(params.partner, params.account, params.operation).subscribe(data => {
                    this.items = data;
                    this.getTableList({db_name: data['database_name'], db_type: data['database_type']});
                    this.getSelectedAttributes(data['projections']);
                });
            });
    }
    getSelectedAttributes(data) {
        const attributeList = [];
        data.include_fields.forEach((attribute) => {
            attributeList.push(attribute.attribute);
        });
        this.attributeSelected = attributeList;
    }
    getTableList(val) {
//   this.dbObj = val;
        const that = this;
        this.tableList = [];
        this.entityList = [];
        this.dbItem.databases.filter(items => {
            if (items.database_name === val.db_name) {
                items.accounts.forEach((accounts) => {
                    accounts.entities.forEach((entities) => {
                        this.entityList.push(entities);
                        this.tableList.push(entities.entityname);
                    });
                });
            }
        });
    }
    getAttributeWait() {
        // this.enableQuerySection = true;
        this.enablequery = false;
        const that = this;
        setTimeout(function() {
            that.getAttributeList();
        }, 1000);

    }
    getAttributeList() {
        const that = this;
        this.query = this.items['conditions'][0];
        this.enablequery = true;
        that.config.fields = {};
        const tablelist = this.items['collections'][0]['table_name'];
        this.attributeList = [];
        this.entityList.filter(items => {
            if (tablelist.indexOf(items.entityname) > -1) {
                items.attributes.forEach((attributes) => {
                    that.config.fields[attributes.attributeName]
                        = {name: attributes.attributeName , type:
                            (attributes.type.toLowerCase() === 'integer' ? 'number' :
                                (attributes.type.toLowerCase() === 'boolean' ? 'boolean' : 'string')) };
                    this.attributeList.push(attributes.attributeName);
                });
            }
        });
    }
    getProjectionData(data) {
        const result = {};
        result['include_fields'] = [];
        result['exclude_fields'] = [];
        data.forEach((proj) => {
            const sun_res = {};
            sun_res['table_name'] = '';
            sun_res['table_alias'] = '';
            sun_res['attribute'] = proj;
            sun_res['attribute_alias'] = '';
            sun_res['aggregate_function'] = '';
            result['include_fields'].push(sun_res);
        });
        return  result;
    }
    getCollectionsData(data) {
        const result = {};
        result['table_name'] = data;
        return result;
    }
    getQueryCondition() {
        const constructQueryPayLoad = {
            'operation_name': this.operationName,
            'database_name': this.items['database_name'],
            'database_type': this.items['database_type'],
            'input_format': 'JSON',
            // 'table_list': this.tableSelected,
            'projections': this.getProjectionData(this.attributeSelected),
            'operation_type': this.method,
            'level_of_access': this.levelSelected,
            'scope_of_access': this.scopeSelected,
            'collections': [this.getCollectionsData(this.items['collections'][0]['table_name'])],
            'conditions': [this.query],
            'sort_by': [],
            'result_format': ['JSON'],
            'group_by': []
        };
        // $('.q-input-control').each(function () {
        //     if ($(this).val().trim() === '') {
        //         $(this).focus();
        //         return false;
        //     }
        // });
    }
}
